<template>
    <div class="page">
        <div
            class="loading-page"
            :class="[showLoadingPage ? (enter ? 'active' : '') : 'hide']"
        >
            <img
                @click="enter = true"
                class="enter"
                src="~@/assets/2020year-end/enter.png"
                alt=""
            />
        </div>
        <div id="flipbook">
            <div class="catalog page-box">
                <div class="container">
                    <div
                        class="box"
                        v-for="(item, index) in catalog"
                        :key="index"
                    >
                        <div class="left">
                            {{ item.type }}
                        </div>
                        <div class="right">
                            <div
                                class="item"
                                v-for="child in item.children"
                                :key="child.title"
                                @click="goPage(child)"
                            >
                                <div class="title-box">
                                    <span class="circle">{{ child.rank }}</span>
                                    <span class="title">{{ child.title }}</span>
                                    <img
                                        v-if="child.free"
                                        class="free"
                                        src="~@/assets/2020year-end/free.png"
                                        alt=""
                                    />
                                </div>
                                <img
                                    class="arrow"
                                    src="~@/assets/2020year-end/arrow.png"
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <img
                    class="buy-btn"
                    src="~@/assets/2020year-end/buy-btn.png"
                    alt=""
                    v-if="!ifBuy"
                    @click="goBuy()"
                />
            </div>
            <div
                class="page-box"
                :class="'page' + count"
                v-for="count in 12"
                :key="count"
            >
                <div class="abstract" v-html="abstracts[count - 1]"></div>
            </div>
        </div>
        <div class="footer">
            <div class="pagation">
                <div
                    class="item"
                    :class="[page == count ? 'active' : '']"
                    v-for="count in pageList.length + 1"
                    :key="count"
                ></div>
            </div>
            <button
                class="go"
                :class="[page > 1 ? 'active' : '']"
                @click="goArticle()"
            >
                <span>点击查看</span>
                <img
                    class="thumb"
                    src="~@/assets/2020year-end/thumb.png"
                    alt=""
                />
            </button>
        </div>
    </div>
</template>

<script>
    import catalog from "./catalog";
    import abstracts from "./abtracts";
    import yearEndService from "../../service/2020year-end.service";
    import { Toast } from "vant";
    import { CatalogItem } from "../../types/2020year-end";
    export default {
        name: "test",
        data() {
            return {
                catalog,
                abstracts,
                page: 1,
                enter: false,
                ifBuy: false,
                pageList: [],
                ifCansee: false,
                ifCanseeTime: "",
                episode: {
                    id: undefined,
                    studyId: undefined,
                },
                showLoadingPage: true,
            };
        },
        created() {
            this.showLoadingPage =
                this.$route.query.loadingPage == 0 ? false : true;
            yearEndService.getStudyDetail().then((res) => {
                this.ifBuy = res.data.ifBuy;
                this.ifCansee = res.data.ifCansee;
                this.ifCanseeTime = res.data.ifCanseeTime;
                this.pageList = res.data.episodes;
                for (let i = 0; i < res.data.episodes.length; i++) {
                    let item = res.data.episodes[i];
                    if (i == 0) {
                        let child = (this.catalog[0].children[0] = new CatalogItem(
                            i + 1,
                            undefined,
                            true
                        ));
                        this.setObjId(child, item);
                    } else if (i >= 1 && i < 6) {
                        let child = (this.catalog[1].children[
                            i - 1
                        ] = new CatalogItem(i + 1));
                        this.setObjId(child, item);
                    } else if (i >= 6 && i < 10) {
                        let child = (this.catalog[2].children[
                            i - 6
                        ] = new CatalogItem(i + 1));
                        this.setObjId(child, item);
                    } else if (i >= 10) {
                        let child = (this.catalog[3].children[
                            i - 10
                        ] = new CatalogItem(i + 1));
                        this.setObjId(child, item);
                    }
                }
            });
        },
        mounted() {
            $("#flipbook").turn({
                autoCenter: true,
                display: "single",
                elevation: 50,
                page: 1,
                gradients: true,
                when: {
                    turning: (e, page) => {
                        this.page = page;
                    },
                    turned: (e, page) => {
                        if (this.pageList.length > 0 && page > 1) {
                            this.episode.id = this.pageList[page - 2].id;
                            this.episode.studyId = this.pageList[
                                page - 2
                            ].studyId;
                        }
                    },
                },
            });
            $("#flipbook").swipeleft(() => {
                $("#flipbook").turn("next");
            });
            $("#flipbook").swiperight(() => {
                $("#flipbook").turn("previous");
            });
            $("#flipbook").turn("peel", "br");
        },
        methods: {
            setObjId(child, item) {
                child.title = item.title;
                child.id = item.id;
                child.studyId = item.studyId;
                return child;
            },
            goBuy() {
                let id = "541BA5202FA6A499D56885A4F0F0126B";
                if (process.env.NODE_ENV == "development") {
                    id = "09F0DF236007BAE6005533CC5901DAD0";
                }
                this.$router.push(`/course-detail/${id}/STUDY`);
            },
            goArticle() {
                if (this.page == 2) {
                    this.goArticleDetail();
                    return;
                }
                if (!this.ifBuy) {
                    this.goBuy();
                } else {
                    if (!this.ifCansee) {
                        Toast(`请在${this.ifCanseeTime}之后，进行阅读`);
                    } else {
                        this.goArticleDetail();
                    }
                }
            },
            goPage(obj) {
                this.episode.studyId = obj.studyId;
                this.episode.id = obj.id;
                if (obj.free) {
                    this.goArticleDetail();
                    return;
                }
                if (!this.ifBuy) {
                    this.goBuy();
                } else {
                    if (!this.ifCansee) {
                        $("#flipbook").turn("page", obj.rank + 1);
                    } else {
                        this.goArticleDetail();
                    }
                }
            },
            goArticleDetail() {
                this.$router.push({
                    path: "/2020year-end-article",
                    query: {
                        courseId: this.episode.studyId,
                        id: this.episode.id,
                    },
                });
            },
        },
    };
</script>

<style lang="scss" scoped src="./2020year-end.scss"></style>
